// src/routes/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * ProtectedRoute wrapper for createBrowserRouter 'element' entries.
 *
 * Props:
 *  - children: React element to render when authorized
 *  - redirectTo: path to redirect when not authenticated (default "/login")
 *  - requireOtpVerified: if true, ensures isOtpVerified === true (default false)
 *
 * Usage:
 *  <ProtectedRoute requireOtpVerified={true}><Profile /></ProtectedRoute>
 */
const ProtectedRoute = ({ children, redirectTo = "/login", requireOtpVerified = false }) => {
  const { token, isOtpVerified } = useSelector((state) => state.auth || {});

  const isAuthenticated = Boolean(token);

  if (!isAuthenticated) {
    // Not logged in
    return <Navigate to={redirectTo} replace />;
  }

  if (requireOtpVerified && !isOtpVerified) {
    // Logged in but OTP not verified — send to OTP verify page
    return <Navigate to="/verify-otp" replace />;
  }

  // Authorized
  return children;
};

export default ProtectedRoute;
